if($('header#header').length){
    
    $('a[data-target="login"]').text(translation('mujucet'));
     $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools'); 
    $('input[type="search"]').attr('placeholder', translation('hledatPlaceholder'))
    $('.responsive-tools').prepend($('.top-navigation-tools .dropdown').clone())
    $('.header-top .navigation-buttons').append($('.top-navigation-bar .responsive-tools'))
   $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner'); 
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    });
    $('.navigationActions').append($('.top-navigation-bar .top-navigation-bar-menu').html());
    $('#formLoginIncluded').prepend('<div class="h4">'+translation('loginTitle')+'</div>')
    $('nav#navigation .menu-level-3').each(function(){
        if($(this).find('li').length>4){
            $(this).addClass('haveMany').append('<li class="last"><a href="'+$(this).closest('.menu-level-2').prev('a').attr('href')+'">'+translation('showAll')+'</a></li>')
        }
    })
}



 $(document).ready(function () {
        let target = 'cart';
        let timeout;
        const $cartHoverArea = $('a[data-target="cart"]');
        $cartHoverArea.on('mouseenter', function () {
            var show = (target === 'cart' && !$('a[data-target="cart"]').hasClass('full')) ? false : true;
            shoptet.popups.showPopupWindow(target, show);
        });

});

